import React from 'react';

const BODY_IMAGES = {
  limousine: '/vehicle-sketch/limousine.webp',
  kombi: '/vehicle-sketch/kombi.webp',
  suv: '/vehicle-sketch/suv.webp',
  cabrio: '/vehicle-sketch/cabrio.webp',
  coupe: '/vehicle-sketch/coupe.webp',
  transporter: '/vehicle-sketch/transporter.webp',
};

const normalize = (v) => String(v || '').toLowerCase()
  .replace(/[ä]/g, 'ae').replace(/[ö]/g, 'oe').replace(/[ü]/g, 'ue')
  .replace(/ß/g, 'ss').trim();

const detectBodyType = (vehicle) => {
  if (!vehicle) return 'limousine';
  const text = `${normalize(vehicle.brand)} ${normalize(vehicle.model)}`;
  const type = normalize(vehicle.vehicle_type);
  if (['transporter','lkw','bus','wohnmobil'].includes(type) ||
      /master|sprinter|crafter|ducato|boxer|jumper/.test(text)) return 'transporter';
  if (/g63|g 63|g-class|g klasse|gle|glc|gls|x3|x5|x6|x7|rsq8|rs q8|sq8|q8|q7|q5|q3|urus|cayenne|macan|touareg|range rover|defender|model x|model y/.test(text)) return 'suv';
  if (/cabrio|convertible|roadster|spyder|spider/.test(text)) return 'cabrio';
  if (/coup[eé]|coupe|c63s|c63 s|m4|m2|m8|r8|vantage|amg gt|911|panamera/.test(text)) return 'coupe';
  if (/kombi|avant|touring|estate|variant|t-model/.test(text)) return 'kombi';
  return 'limousine';
};

const ZONES = [
  {view:'front',left:.02,top:.21,width:.32,height:.30},
  {view:'top',left:.33,top:.21,width:.34,height:.30},
  {view:'rear',left:.67,top:.21,width:.31,height:.30},
  {view:'left',left:.02,top:.50,width:.65,height:.24},
  {view:'right',left:.67,top:.50,width:.31,height:.24},
  {view:'hood',left:.02,top:.74,width:.18,height:.24},
  {view:'trunk',left:.20,top:.74,width:.18,height:.24},
  {view:'interior',left:.38,top:.74,width:.18,height:.24},
  {view:'roof',left:.56,top:.74,width:.18,height:.24},
  {view:'underbody',left:.74,top:.74,width:.24,height:.24},
];

export default function VehicleSketch({vehicle,markers=[],readonly=false,onAddMarker,onRemoveMarker}) {
  const bodyType = detectBodyType(vehicle);
  const add = (zone,e) => {
    if (readonly || !onAddMarker) return;
    const r=e.currentTarget.getBoundingClientRect();
    onAddMarker(zone.view,
      Math.max(0,Math.min(1,(e.clientX-r.left)/r.width)),
      Math.max(0,Math.min(1,(e.clientY-r.top)/r.height)));
  };
  return (
    <div className="w-full">
      <div className="mb-3 flex items-center justify-between">
        <div>
          <div className="text-sm font-semibold text-[#111827]">Fahrzeug-Schadenskizze</div>
          <div className="text-xs text-[#6B7280]">{vehicle?.brand || ''} {vehicle?.model || ''} · {bodyType === 'coupe' ? 'Coupé' : bodyType[0].toUpperCase()+bodyType.slice(1)}</div>
        </div>
        <div className="text-xs text-[#8A94A6]">Klicken = Schaden markieren · roten Punkt anklicken = entfernen</div>
      </div>
      <div className="relative w-full overflow-hidden rounded-xl border border-[#D9DDE3] bg-white">
        <img src={BODY_IMAGES[bodyType]} alt={`Fahrzeug-Schadenskizze ${bodyType}`} className="block w-full h-auto select-none" draggable="false" />
        {!readonly && ZONES.map(z => (
          <button key={z.view} type="button" aria-label={`${z.view} Schaden markieren`}
            onClick={e=>add(z,e)} className="absolute border-0 bg-transparent cursor-crosshair"
            style={{left:`${z.left*100}%`,top:`${z.top*100}%`,width:`${z.width*100}%`,height:`${z.height*100}%`}} />
        ))}
        {markers.map((m,i)=>{
          const z=ZONES.find(x=>x.view===(m.view||'top')); if(!z) return null;
          const x=z.left+(Number(m.x)||0)*z.width, y=z.top+(Number(m.y)||0)*z.height;
          return <button key={i} type="button" aria-label={`Schaden ${i+1} entfernen`}
            onClick={e=>{e.stopPropagation();if(!readonly&&onRemoveMarker)onRemoveMarker(i)}}
            className="absolute -translate-x-1/2 -translate-y-1/2 flex h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-red-600 text-xs font-bold text-white shadow-lg"
            style={{left:`${x*100}%`,top:`${y*100}%`}}>{i+1}</button>;
        })}
      </div>
    </div>
  );
}
